import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {Email} from '../../../../components/Email';

class GeneralConditions extends React.Component {

  public render() {
    return (
      <div className="container">
        <Row>
          <Col sm={12}>
            <h2>CONDITIONS GENERALES D'UTILISATION DU SITE eRCpro</h2>

            <h3>PRÉAMBULE</h3>
            <p>
              Les présentes conditions générales d’utilisation sont applicables à la souscription en ligne de contrats
              d’assurance.
            </p>
            <p>
              Ces contrats sont assurés par MS Amlin Insurance SE, Société Européenne de droit belge au capital de 1 321
              489 euros, dont le siège social est situé 37 Boulevard Roi Albert II 1030 Bruxelles (Belgique) -
              Immatriculée à la BCE (Banque-Carrefour des Entreprises) à Bruxelles sous le numéro 0644 921 425 et
              soumise au contrôle de la BNB (Banque nationale de Belgique).  et dont la succursale en France est située
              58 bis rue La Boétie 75008 Paris- T +33 (0) 1 44 70 71 00 F +33 (0) 1 42 93 47 42 -
              <Email email={'contact.france@msamlin.com'}/>.
            </p>
            <p>
              L’utilisateur est ci-après dénommé « le Client » en phase de souscription. Il devient preneur du contrat à
              compter de l’émission par MS Amlin Insurance SE des Conditions particulières.
            </p>
            <p>
              Toute souscription en ligne à un contrat visé en préambule, sur le site Internet eRCpro (ci-après dénommé
              le « Site ») entraîne l´adhésion pleine et entière du Client aux présentes Conditions générales
              d’utilisation sans exception ni réserve.
            </p>
            <p>
              Le présent document qui s’ajoute au contrat d’assurance  constitue les Conditions générales de
              souscription en ligne à un contrat visé en préambule et disponible sur le site eRCpro.
            </p>

            <h3>1. ACCEPTATION DES CONDITIONS GENERALES D'UTILISATION DU SITE</h3>
            <p>
              Le Client ne peut bénéficier des services du Site que sous réserve de l'acceptation des présentes
              conditions générales d’utilisation.
            </p>
            <p>
              Le Client déclare :
            </p>
            <ul>
              <li>avoir pris connaissance des conditions dans lesquelles fonctionne le Site, notamment par le biais des
                présentes conditions générales d'utilisation, et les avoir comprises ;</li>
              <li>être juridiquement capable de contracter ;</li>
              <li>s'être assuré du respect des prérequis techniques nécessaires qu'il déclare satisfaire ;</li>
              <li>s'engager à utiliser le Site conformément aux présentes conditions générales d'utilisation.</li>
            </ul>
            <p>
              Le Client reconnaît et accepte que l'acceptation des présentes ne nécessite pas la signature de celles-ci
              et que l'acceptation électronique constitue la preuve que le Client a lu et a pris connaissance desdites
              dispositions et vaut acceptation des présentes.
            </p>
            <p>
              Les présentes conditions générales d’utilisation entrent en vigueur à la date de leur mise en ligne.
            </p>
            <p>
              Elles sont opposables au Client dès leur acceptation par ce dernier pendant toute la durée de navigation
              sur le Site et d'utilisation des services et de l'espace personnel et ce, jusqu'à ce que de nouvelles
              conditions générales d’utilisation les remplacent.
            </p>
            <p>
              MS Amlin Insurance SE se réserve la faculté de modifier à tout moment les présentes Conditions générales
              d’utilisation. En cas de modification, il sera appliqué les Conditions générales d’utilisation en vigueur
              au jour de la demande de souscription.
            </p>
            <p>
              Toutes les informations tarifaires et contractuelles sont proposées au Client à chaque étape de
              souscription lui garantissant une parfaite connaissance des caractéristiques essentielles du contrat
              proposé avant sa demande de souscription en ligne.
            </p>
            <p>
              La date d’effet du contrat définie selon les règles exposées au contrat d’assurance est choisie en ligne
              par le Client.
            </p>
            <p>
              Il est par ailleurs entendu que les offres proposées par le Sites ont accessibles sous certaines
              conditions liées notamment à la capacité juridique, au pays de naissance et de résidence, à la
              nationalité, au secteur d'activité ou à l'origine du patrimoine.
            </p>
            <p>
              Le Client garantit l'exactitude à tout moment des informations fournies à MS Amlin Insurance SE pour créer
              son compte sur le Site. Le Client s'engage à informer sans délai MS Amlin Insurance SE de toute
              modification dans ces informations, étant précisé que la fourniture et l'exactitude de ces informations
              ont un impact sur le respect par MS Amlin Insurance SE de ses obligations légales. Le Client reconnaît et
              accepte que cette obligation constitue une obligation substantielle.
            </p>
            <p>
              Le Site est accessible 7j/7 et 24h/24 avec un taux de disponibilité élevé. L’accès au Site peut néanmoins
              être temporairement impossible pour des raisons de maintenance, avec ou sans préavis, sans que le Client
              puisse prétendre à une quelconque indemnité de ce fait.
            </p>

            <h3>2. LES ÉTAPES DE LA SOUSCRIPTION</h3>
            <p>
              Le Client, pour passer à la phase de souscription en ligne doit suivre le processus ci-après :
            </p>
            <p>
              Le client complète un questionnaire en ligne permettant au Client d’exprimer ses besoins et à MS Amlin
              Insurance SE d’apprécier le risque et de déterminer si le Client remplit les conditions de souscription
              en ligne.
            </p>
            <p>
              Lorsque le Client a complété le questionnaire et s’il remplit les conditions de souscription en ligne, une
              proposition d’assurance lui est adressée ainsi que les Conventions spéciales et ses Annexes, les
              Conditions Générales, le document d’information sur le produit d’assurance et la fiche relative à
              l’application de la garantie dans le temps. Ces informations sont également téléchargeables sur l’espace
              personnel du Client.
            </p>
            <p>
              Le client confirme son accord sur les conditions proposées et peut alors effectuer le paiement de sa
              prime d’assurance via un site sécurisé.
            </p>
            <p>
              La souscription s’effectue en plusieurs étapes, dont le contenu et les modalités peuvent le cas échéant
              être adaptés en fonction des produits concernés.
            </p>
            <p>
              Toutes les informations, tarifaires et contractuelles, sont obligatoirement proposées aux Client lors des
              étapes de souscription.
            </p>
            <p>
              Le Client dispose d’un accès direct, permanent et facile à ces informations.
            </p>
            <p>
              Le Client déclare fournir des informations sincères et à sa connaissance, exactes, lors de la demande
              d’établissement des documents contractuels.
            </p>
            <p>
              Le contrat d’assurance souscrit en ligne est réputé être formé dès émission par MS Amlin Insurance SE des
              Conditions Particulières.
            </p>

            <h3>3. RESPONSABILITE</h3>
            <p>
              MS Amlin Insurance SE n’est en aucun cas responsable des préjudices qui pourraient résulter (i) d’une
              compromission (comprenant oubli, perte, vol, etc.) des moyens d’authentification du Client, (ii) d’un
              dysfonctionnement du réseau internet ou de l’infrastructure informatique d’un partenaire de MS Amlin
              Insurance SE, (iii) d’un dysfonctionnement de l’équipement informatique du Client, (iv) d’une inexécution
              par le Client de ses obligations au titre des présentes CGU ou de tout autre engagement relatif aux offres
              présentées par le Site, ou (v) d’un cas de Force Majeure au sens de l’article 1218 du Code civil.
            </p>
            <p>
              Le Client s'engage :
            </p>
            <ul>
              <li>à n'utiliser le Site, son espace personnel et les informations auxquelles il aurait accès que dans
                les seules conditions définies dans les présentes.</li>
              <li>à ne pas perturber l'usage que pourraient faire les autres utilisateurs du Site et de ne pas accéder
                aux espaces personnels de tiers.</li>
              <li>à ne commettre aucun acte pouvant mettre en cause la sécurité informatique de la société MS Amlin
                Insurance SE ou des autres utilisateurs.</li>
              <li>à ne pas interférer ou interrompre le fonctionnement normal du Site.</li>
            </ul>
            <p>
              Le Client ne pourra pas rendre responsable la société MS Amlin Insurance SE d'un quelconque différé dans
              les informations qui lui seront remises.
            </p>
            <p>
              Sauf faute ou négligence prouvée de la société MS Amlin Insurance SE, les atteintes à la confidentialité
              des données personnelles de l'utilisateur résultant de ses codes d'accès par un tiers ne sauraient engager
              la responsabilité de la société MS Amlin Insurance SE.
            </p>
            <p>
              MS Amlin Insurance SE ne saurait être responsable de la violation des présentes conditions générales
              d'utilisation par un autre utilisateur.
            </p>
            <p>
              La responsabilité de MS Amlin Insurance SE ne pourra être recherchée ni retenue en cas d'indisponibilité
              temporaire ou totale de tout ou partie de l'accès au Site et à l'espace personnel du Client, d'une
              difficulté liée au temps de réponse, et d'une manière générale, d'un défaut de performance quelconque.
            </p>

            <h3>4. LA SÉCURITÉ</h3>
            <p>
              Les informations collectées dans le cadre d’une souscription en ligne à un contrat visé en préambule sont
              confidentielles. Tous les moyens de sécurité nécessaires ont été mis en place par MS Amlin Insurance SE.
            </p>
            <p>
              Le Client est néanmoins informé que MS Amlin Insurance SE ne saurait assurer une sécurité absolue.
            </p>
            <p>
              Le Client déclare accepter les caractéristiques et limites de l'internet. Il reconnaît avoir connaissance
              de la nature du réseau de l'internet, et en particulier, de ses performances techniques et des temps de
              réponse pour consulter, interroger ou transférer les données d'informations.
            </p>
            <p>
              Le Client a conscience que les données circulant sur l'internet ne sont pas nécessairement protégées,
              notamment contre les détournements éventuels.
            </p>
            <p>
              Le Client accepte de prendre toutes les mesures appropriées de façon à protéger ses propres données et/ou
              logiciels de la contamination par des éventuels virus sur le réseau de l'internet.
            </p>
            <p>
              Vous pouvez avoir plus de détails sur la page « Mentions Légales » de notre site.
            </p>

            <h3>5. PROTECTION DES DONNEES PERSONNELLES</h3>
            <p>
              MS Amlin Insurance SE, en qualité de responsable de traitement, recueille et traite des données à
              caractère personnel dans le cadre des offres proposées par le Site aux fins d’exécuter les contrats
              conclus. La base juridique de ces traitements repose sur la relation contractuelle avec MS Amlin Insurance
              SE ou ses partenaires et/ou sur les obligations légales ou réglementaires de MS Amlin Insurance SE ou de
              ses Partenaires.
            </p>
            <p>
              Les données à caractère personnel recueillies par MS Amlin Insurance SE sont obligatoires pour pouvoir
              proposer les offres et exécuter les contrats afférents. La non-fourniture de ces données peut avoir pour
              conséquence l’impossibilité de conclure une offre ou exécuter les contrats.
            </p>
            <p>
              Les données à caractère personnel du Client pourront aussi être utilisées à des fins de prospection de
              type newsletter ainsi que pour proposer des animations à la communauté des Clients si ceux-ci souhaitent
              s’y inscrire. La base juridique de ces traitements repose sur l’intérêt légitime de MS Amlin Insurance SE,
              aux fins de faire connaître largement à ses Clients ses activités et services. Le Client peut à tout
              moment refuser de recevoir ce type de sollicitation.
            </p>
            <p>
              Les données à caractère personnel du Client seront conservées pour une durée adaptée à la finalité de
              chaque offre, sans que cette durée puisse excéder un délai de deux années après la cessation de la
              relation contractuelle. Par exception, ces données pourront être conservées pendant des durées plus
              longues pour gérer les réclamations et contentieux en cours, ainsi que pour répondre à des obligations
              légales et/ou réglementaires, et/ou encore pour répondre aux demandes des autorités.
            </p>
            <p>
              Les données à caractère personnel peuvent être transmises aux partenaires de MS Amlin Insurance SE, en
              tant que de besoin, pour la construction des offres et l’exécution des contrats conclus. Elles peuvent
              également être transmises à des prestataires de services pour l’exécution de travaux sous-traités par MS
              Amlin Insurance SE.
            </p>
            <p>
              Le Client dispose du droit de demander l’accès à ses données à caractère personnel et la rectification des
              données inexactes. Le Client peut demander l’effacement de ses données et la limitation du traitement,
              dans les limites prévues par la législation applicable, étant précisé que l’exercice de ces droits peut,
              le cas échéant, avoir pour conséquence la perte du statut de Client ou l’impossibilité de conclure ou
              exécuter certains contrats. Le Client dispose du droit à la portabilité des données à caractère personnel
              qu’il a fournies à MS Amlin Insurance SE, dans les conditions prévues par la législation applicable.
            </p>
            <p>
              Le Client dispose également du droit de définir des directives générales et particulières relatives à la
              conservation, à l’effacement et à la communication après son décès de ses données à caractère personnel
              traitées par la Société, conformément aux dispositions législatives et réglementaires applicables.
            </p>
            <p>
              Le Client peut exercer les droits dont il dispose en écrivant à l’adresse ci-après sous réserve de dûment
              justifier de son identité en joignant à sa demande une copie d’un titre officiel d’identité :
            </p>
            <p>
              Délégué à la protection des données (The Data Protection Officer)<br />
              MS Amlin limited<br />
              The Leadenhall Building<br />
              122 Leadenhall Street<br />
              Londres, Royaume-Uni<br />
              EC3V 4AG
            </p>
            <p>
              E-mail : <Email email={'DataProtectionOfficer@msamlin.com'}/>
            </p>
            <p>
              Le Client est informé de la possibilité d’introduire une réclamation relative aux traitements de vos
              données à caractère personnel auprès de la Commission Nationale Informatique et Libertés (CNIL) –
              www.cnil.fr – 3 place de Fontenoy 75007 Paris.
            </p>
            <p>
              L’avis complet relatif à la protection des données des clients est accessible en cliquant sur le lien
              suivant :&nbsp;
              <a href="https://www.msamlin.com/en/site-services/data-privacy-notice/avis-de-la-protection-
des-donnees-des-clients.html" target="_blank">
                https://www.msamlin.com/en/site-services/data-privacy-notice/avis-de-la-protection-des
                -donnees-des-clients.html
              </a>
            </p>

            <h3>6. PROPRIETE INTELLECTUELLE</h3>
            <p>
              Les contenus accessibles sur le Site, quelle que soit leur forme : texte, logo, marque, photo, etc.
              (les « Contenus ») sont la propriété exclusive de MS Amlin Insurance SE ou de ses ayants-droits.
            </p>
            <p>
              Le Client s’interdit toute réutilisation, modification, ou reproduction d’un Contenu, à peine de
              contrefaçon, passible de sanctions civiles et pénales.
            </p>

            <h3>7. LIENS HYPERTEXTES ET VIRUS</h3>
            <p>
              Le site peut inclure des liens vers d’autres sites ou d’autres sources Internet. Dans la mesure où MS
              Amlin Insurance SE ne peut contrôler ces sites et ces sources externes, MS Amlin Insurance SE ne peut être
              tenu pour responsable de la mise à disposition de ces sites et sources externes, et décline ainsi toute
              responsabilité quant aux contenus, publicités, produits, services ou tout autre matériel disponible sur ou
              à partir de ces sites ou sources externes. La décision d’activer les liens vous appartient exclusivement.
              Il vous appartient également de prendre les précautions nécessaires pour vous assurer que le site que vous
              sélectionnez ne contient pas de virus ou autre parasite de nature destructive.
            </p>

            <h3>8. ACCÈS AU SITE ET CONVENTION DE PREUVE</h3>
            <p>
              Le Client conserve à sa charge les frais de télécommunication lors de l’accès à Internet et au site
              eRCpro.
            </p>
            <p>
              Le Client accepte que :
            </p>
            <ul>
              <li>Les présentes CGU sous forme électronique aient entre les parties la même valeur probante que
                l’accord sur support papier ;</li>
              <li>Les éléments d’identification, les enregistrements informatiques, soient admissibles devant les
                tribunaux et fassent preuve des données, des consentements et des faits qu’ils contiennent ;</li>
              <li>Les marques de temps soient admissibles devant les tribunaux et fassent preuve des données et des
                faits qu’elles contiennent ;</li>
              <li>Les documents échangés sous forme électronique soient admissibles devant les tribunaux et fassent
                preuve des données et des faits qu’ils contiennent ;</li>
            </ul>

            <h3>9. LANGUE ET LOI APPLICABLE</h3>
            <p>
              Les informations contractuelles sont présentées en langue française et sont soumises au droit français.
            </p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(GeneralConditions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/GeneralConditions/index.tsx